import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden rounded-lg mb-4 aspect-[16/10]">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full">
            {article.tags[0]}
          </span>
          <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2 mt-3">
          <div className="w-6 h-6 rounded-full overflow-hidden flex-shrink-0">
            <img
              src={article.authorAvatar}
              alt={article.author}
              className="w-full h-full object-cover"
            />
          </div>
          <span className="text-xs text-foreground-500">{article.author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{article.publishDate}</span>
        </div>
      </Link>
    </article>
  );
}